module.exports = __webpack_public_path__ + "media/app/assets/specializations/death_knight/unholy-9c76e2d244e0f0d2f20ee7b67f0d1a80.png";